import { ESortRule } from './../../enums/ESortRule';
import { EOrderType } from './../../enums/EOrderType';
import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import { defaultSortData, sortMap, IOYOrderBarData, IOYOrderBarProps, IOYOrderBarState, ITOYOrderBarPublishPriceData, ITOYOrderBarSelectData, TOYOrderBarData } from "./const";
import OY from '../../types/OY';
import { jeact } from '../../decorators/jeact';
import OYInput from '../OYInput';
import { isArray, isObject, stringSet } from '../../utils';

@jeact({ autoRender: true })
export default class OYOrderBar extends OY<IOYOrderBarProps, IOYOrderBarState> {
  static displayName = 'OYOrderBar';

  static defaultProps: Partial<IOYOrderBarProps> = {
    data: defaultSortData,
    rules: [['*']],
    publishPrice: '',
    search: true
  };

  state: IOYOrderBarState = {
    data: [],
    publishPrice: ['', '']
  }

  $node = {
    input: $(),
    iconSearch: $(),
    orderItems: $(),
    selectContentItems: $(),
    startInputData: $(),
    endInputData: $()
  }

  validRule: string[] = [];

  getDerivedStateFromProps(nextProps: IOYOrderBarProps, state: IOYOrderBarState) {
    let { data, publishPrice } = state;
    if (!this.props || this.props.data !== nextProps.data) {
      const sdata = this._convertPropData2StateData(JSON.parse(JSON.stringify(nextProps.data)))
      data = sdata.map(da => {
        if (this._isSelectData(da)) {
          const result = (da.info || []).find(info => info.sortRule);
          if (result) {
            (da as ITOYOrderBarSelectData)._name = result.name;
          }
        }
        return da
      })
    }
    if (!this.props || this.props.publishPrice !== nextProps.publishPrice) {
      const price = (nextProps.publishPrice || '').split(',');
      publishPrice = ['', ''].map((va, index) => price[index] || va);
    }

    return { ...state, data, publishPrice };
  }

  render() {
    const goodsMode = this.state.data.find(item => item.type === 6);
    return template({ props: this.props, state: this.state, styles,goodsMode })
  }

  renderPublishPrice() {
    this.$el.find('oy-input-range').OYInputRange({
      value: this.state.publishPrice,
      prefix: '¥',
      valtype: 'positiveFloat',
      decimal: 2,
      placeholder: ['最低价', '最高价'],
      onChange: (cvalue: string[]) => {
        this.state.publishPrice = cvalue;
      }
    })
    this.$el.find('oy-button').OYButton({
      onClick: () => {
        this._handlePublishPriceRanges();
        this.eventEmitter.emit('onPublishPriceChange', this.state.publishPrice.join(','))
      }
    })
  }

  renderSearch() {
    const input: OYInput = this.$el.find('oy-input').OYInput({
      onSearch: (value: string) => {
        if (value) {
          input.clear();
          this.eventEmitter.emit(EEventType.onSearch, value)
        }
      }
    })
  }

  setNode() {
    this.$node = {
      input: this.$el.find(`.${styles.input}`),
      iconSearch: this.$el.find(`.${styles.icon_search}`),
      orderItems: this.$el.find(`.${styles.oy_orderBar_item}`),
      selectContentItems: this.$el.find(`.${styles.selectContent_item}`),
      startInputData: this.$el.find('input[name=start]'),
      endInputData: this.$el.find('input[name=stop]')
    }
  }

  /**
   * 清空排序。并返回数据
   * @param emit 是否emmit
   * @exports
   */
  clearSort(emit = false, type: EOrderType) {
    let data = this._clearAllRule();
    this.validRule = this.props.rules![0];
    data = data.map((da, idx) => {
      if (da.type === type) {
        if (da.type === EOrderType.None || type === EOrderType.Pay) {
          (da as IOYOrderBarData).sortRule = ESortRule.Desc;
        }
      }
      return da
    })
    this.setState({ data }, () => {
      if (emit) {
        this._emitChange();
      }
    });
  }

  bindOrderItem() {
    this.$node.orderItems.click((ev: Event) => {
      const $element = $(ev.currentTarget!);
      const index = $element.data('index');
      const orderItem = this.state.data[index] as IOYOrderBarData;
      const { type, sortType, defaultRule } = orderItem
      let { sortRule } = orderItem;
      // 重置
      if (type === EOrderType.None) {
        if (!$element.hasClass(styles.checked)) {
          this.clearSort(true, type);
        }
      // 重置 + 设置值
      // 意向金支付是一个单独的选项，与新货优先互斥
      } else if (type === EOrderType.Pay) {
        if (!$element.hasClass(styles.checked)) {
          this.clearSort(false, type);
          this.eventEmitter.emit(EEventType.onChange, [{sortRule: '0', sortType: 'isIntentionPayment'}, null])
        }
      } else {
        this._removeDefaultCheck();
        if (type === EOrderType.Radio) {
          if ($element.hasClass(styles.checked)) {
            return;
          }

          let data = this._validRule(sortType);
          data = data.map((da, idx) => {
            // 意向金支付是一个单独的选项，与新货优先互斥
            if (da.type === EOrderType.Pay) {
              (da as IOYOrderBarData).sortRule = ESortRule.None;
            }
            if (index === idx) {
              (da as IOYOrderBarData).sortRule = ESortRule.Desc;
            }
            return da
          })
          this.setState({ data }, () => {
            this._emitChange();
          });
        } else if (type === EOrderType.Sort) {
          let data = this._validRule(sortType);
          const rules = [defaultRule || ESortRule.Asc];
          rules[1] = rules[0] === ESortRule.Asc ? ESortRule.Desc : ESortRule.Asc;
          // rules.push(ESortRule.None);

          sortRule = rules[(rules.indexOf(sortRule) + 1) % 2];
          // eslint-disable-next-line no-nested-ternary
          // sortRule = sortRule === ESortRule.None ? ESortRule.Desc : sortRule === ESortRule.Desc ? ESortRule.Asc : ESortRule.None;
          data = data.map((da, idx) => {
            if (index === idx) {
              (da as IOYOrderBarData).sortRule = sortRule;
            }
            return { ...da }
          })
          this.setState({ data }, () => {
            this._emitChange();
          });
        }
      }
    })
  }

  bindSelectContent() {
    this.$el.find(`.${styles.selectContent}`).click((ev: Event) => {
      ev.stopPropagation();
    })
  }

  bindSelectContentItems() {
    this.$node.selectContentItems.click((ev: Event) => {
      const $element = $(ev.currentTarget!);
      const parentIndex = $element.data('pindex');
      const index = $element.data('index');

      const orderItem = (this.state.data[parentIndex] as ITOYOrderBarSelectData).info[index]
      const { sortType, sortRule } = orderItem;
      if (sortRule) {
        return;
      }

      this._removeDefaultCheck();
      let data = this._validRule(sortType);

      data = data.map((pdata: any, pIndex) => {
        let _name = pdata.name;
        if (pIndex === parentIndex) {
          pdata.info = pdata.info!.map((info: any, idx: number) => {
            if (idx === index) {
              _name = info.name;
              info.sortRule = info.value;
            } else {
              info.sortRule = ESortRule.None;
            }
            return { ...info }
          })
        }
        return { ...pdata, _name };
      })

      this.setState({ data }, () => {
        this._emitChange();
      })
    })
  }

  /**
   * 清空所有选中规则
   * @param sortType 需要忽略的type
   */
  private _clearAllRule(sortType?: string): TOYOrderBarData[] {
    const data = this.state.data.map((va: any) => {
      if (va.info) {
        (va as ITOYOrderBarSelectData)._name = '';
        va.info = va.info.map((info: any) => {
          return { ...info, sortRule: info.sortType === sortType ? info.sortRule : ESortRule.None }
        })
      }
      const sortRule = va.sortType === sortType ? va.sortRule : ESortRule.None;
      return { ...va, sortRule }
    })
    this.setState({ data });
    return data;
  }

  private _isSelectData(data: TOYOrderBarData): data is ITOYOrderBarSelectData {
    return data.type === EOrderType.Select;
  }

  private _isPublishPriceData(data: TOYOrderBarData): data is ITOYOrderBarPublishPriceData {
    return data.type === EOrderType.PublishPrice
  }

  private _getCheckKey(key?: string) {
    const checkedKeys: string[] = [];

    const checkedKeyMap: { [i: string]: string } = {};
    $.each(this.state.data, (idx, data) => {
      if (this._isSelectData(data)) {
        $.each(data.info, (_index, info) => {
          info.sortRule && (checkedKeyMap[info.sortType] = '');
        })
      } else if (!this._isPublishPriceData(data)) {
        if (data.sortRule && data.type !== EOrderType.None) {
          checkedKeyMap[data.sortType] = ''
        }
      }
    })
    if (key) {
      checkedKeyMap[key] = ''
    }
    $.each(checkedKeyMap, (mkey) => {
      checkedKeys.push(mkey)
    })
    return {
      checkedKeys,
      checkedKeyMap
    };
  }

  private _validRule(ruleKey: string) {
    const { rules } = this.props;
    let { data } = this.state;

    const { checkedKeys } = this._getCheckKey();
    let result: any = this.matchRuleByKeys(ruleKey, checkedKeys, rules!);
    // 如果没有匹配到。则需要排除匹配。
    if (!result.matchedRule.length) {
      result = this.excludeMatchRuleByKeys(ruleKey, checkedKeys, rules!);
      data = result.data;
    }

    this.validRule = result.matchedRule;
    // console.log('validRule', JSON.stringify(result));
    return data;
  }

  /**
   * 根据key查询是否有匹配的规则
   * @param currentKey 当前点击的key
   * @param selectedKeys 已经选中的key
   * @param rules 规则列表
   */
  private matchRuleByKeys(currentKey: string, selectedKeys: string[], rules: string[][]) {
    let matchedRule: string[] = [];
    let originRule: string[] = [];
    // 先直接进行全匹配
    const allkeys = stringSet([currentKey, ...selectedKeys]);
    originRule = rules.find(rule => {
      // 比较长度
      if (rule.length < allkeys.length) {
        return false;
      }
      // 比较模糊匹配数量是否足够
      let starCount = 0;
      let keepCount = 0;
      const namedKeys = rule.filter(ru => {
        if (ru === '*') {
          starCount++;
        }
        return ru !== '*';
      })
      keepCount = allkeys.filter(ak => namedKeys.indexOf(ak) === -1).length

      if (starCount < keepCount) {
        return false;
      }

      return true;
    }) || []

    // 如果能匹配中直接返回匹配结果
    if (originRule.length) {
      const restKeys = allkeys.filter(key => !originRule.includes(key));
      matchedRule = originRule.map(rule => {
        if (rule !== '*') {
          return rule;
        }
        return restKeys.length ? restKeys.shift()! : rule;
      })
    }
    return { matchedRule, originRule };
  }

  private excludeMatchRuleByKeys(currentKey: string, selectedKeys: string[], rules: string[][]) {
    let matchedRule: string[] = [];
    let originRule: string[] = [];
    let { data } = this.state
    // 先直接进行全匹配
    let allkeys = stringSet([currentKey, ...selectedKeys]);

    originRule = rules.find(rule => {
      return rule.indexOf('*') !== -1
    }) || [];
    // 如果有符合的。则处理
    if (originRule.length) {
      matchedRule = originRule.map(rule => {
        if (rule !== '*') {
          allkeys = allkeys.filter(key => key !== rule);
          return rule;
        }
        return allkeys.length ? allkeys.shift()! : rule;
      })

      data = this.removeCheckedDataByKeys(allkeys); // 移除剩余key的选中
    } else { // 没有符合的。则清空规则
      data = this._clearAllRule();
    }

    return { matchedRule, originRule, data }
  }

  private removeCheckedDataByKeys(keys: string[]) {
    const data = this.state.data.map((va: any) => {
      if (va.info) {
        (va as ITOYOrderBarSelectData)._name = '';
        va.info = va.info.map((info: any) => {
          return { ...info, sortRule: keys.indexOf(info.sortType) === -1 ? info.sortRule : ESortRule.None }
        })
      }
      const sortRule = keys.indexOf(va.sortType) === -1 ? va.sortRule : ESortRule.None;
      return { ...va, sortRule }
    })
    return data;
  }

  private _emitChange() {
    const sort: any = {};
    this.state.data.forEach((cur: any) => {
      if (cur.info) {
        cur.info
          .filter((va: any) => va.sortRule && va.type !== EOrderType.None)
          .forEach(({ sortRule, sortType }: any) => {
            sort[sortType] = sortRule;
          })
      } else if (cur.sortRule && cur.type !== EOrderType.None) {
        sort[cur.sortType] = cur.sortRule;
      }
    })

    const data = this.validRule.map(rule => {
      if (rule === '*') {
        return null;
      }
     
      return sort[rule] ? { sortRule: sort[rule], sortType: rule } : null;
    })
    this.eventEmitter.emit(EEventType.onChange, data)
  }

  private _removeDefaultCheck() {
    const data = this.state.data.map((da, idx) => {
      const localData = (da as IOYOrderBarData);
      if (localData.type === EOrderType.None) {
        localData.sortRule = ESortRule.None;
      }
      return { ...localData }
    })
    this.setState({ data })
  }

  private _convertPropData2StateData(data: IOYOrderBarProps['data'] = []): TOYOrderBarData[] {
    const formatData: TOYOrderBarData[] = [];

    const other: any = {
      "name": "其他排序",
      "_name": '',
      "type": EOrderType.Select,
      "info": []
    };
    data.forEach((item:any) => {
      if (item.type === 'mode') {
        const obj:any = {
          name: item.value === 'commodity'?'简洁版':'详细版',
          toggleName:item.value === 'commodity'?'详细版':'简洁版',
          type: EOrderType.Mode,
        };
        formatData.push(obj)
      }
      else if (typeof item === 'string') {
        if (sortMap[item]) {
          formatData.push({
            defaultRule: ESortRule.Asc,
            sortType: item,
            ...sortMap[item]
          })
        }
      } else if (this._isArrary(item)) {
        item.forEach(it => {
          if (typeof it === 'string') {
            const sortData = sortMap[it];
            if (sortData) {
              // 立即交货优先无升降序
              if(sortData.name === '立即交货优先') {
                other.info.push({ ...sortData, sortType: it, name: sortData.name, value: '1' })
              } else {
                other.info.push({ ...sortData, sortType: it, name: sortData.name + '升序', value: '1' })
                other.info.push({ ...sortData, sortType: it, name: sortData.name + '降序', value: '0' })
              }
            }
          } else if (isObject(it) && it.sortType) {
            const sortData = sortMap[it.sortType] || {};
            const name = it.name || sortData.name || '未知';
            other.info.push({ ...sortData, ...it, name: name + '升序', value: '1' })
            other.info.push({ ...sortData, ...it, name: name + '降序', value: '0' })
          }
        });
        formatData.push(other)
      } else {
        formatData.push(item)
      }
    })
    // console.log(formatData, 'formatData');
    return formatData
  }

  private _isArrary(data: any): data is any[] {
    return data instanceof Array
  }

  private _handlePublishPriceRanges(){
    let publishPriceArray: string[] = this.state.publishPrice;
    if(publishPriceArray && publishPriceArray.length == 2){
      if(publishPriceArray[1] != "") {
        if (Number(publishPriceArray[0]) > 0 && Number(publishPriceArray[1]) >= 0 && Number(publishPriceArray[0]) > Number(publishPriceArray[1])) {
          let tempPublishPrice = publishPriceArray[0];
          this.state.publishPrice[0] = publishPriceArray[1];
          this.state.publishPrice[1] = tempPublishPrice;
          this.$node.startInputData.val(this.state.publishPrice[0]);
          this.$node.endInputData.val(this.state.publishPrice[1]);
        }
      }
    }
  }
  toggleMode() {
    const list = [...this.state.data];
    const item :any= list.find(item => item.type === 6);
    const temp = item.name;
    item.name = item.toggleName;
    item.toggleName = temp;
    this.setState({
      ...this.state,
      data:list
    })
  }
  handleCloseTips() {
    this.$class('modeClosePopoverIcon').parent().hide()
    this.eventEmitter.emit(EEventType.onClosePopover)
  }
  bindModeChange() {
    this.$class('balingMode').click(() => {
      this.toggleMode();
      this.eventEmitter.emit(EEventType.onModeChange, { value: 'commodity' });
      this.handleCloseTips();
    })
    this.$class('goodsMode').click(() => {
      this.toggleMode();
      this.eventEmitter.emit(EEventType.onModeChange, { value: 'pack' });
      this.handleCloseTips();
    })
  }
  bindCloseModeTips() {
    this.$class('modeClosePopoverIcon').click(() => {
      this.handleCloseTips();
    })
  }
  bindToolTips() {
    this.$el.find('[data-toggle="tooltip"]').each((_idx, ele) => {
      if (ele.getAttribute('data-original-title') !== '' && ele.getAttribute('data-original-title') !== null) {
        const $ele = $(ele);
        $ele.tooltip()
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/OYOrderBar/index.ts